export enum CodeGenStatus {
  InProgress = 'InProgress',
  InQueue = 'InQueue',
  Default = 'Default'
}

export enum ConnectorStatusTypes {
  PENDING = 'Pending',
  RUNNING = 'Running',
  COMPLETED_SUCCESSFULLY = 'CompletedSuccessfully',
  RETRY_WITH_ERROR = 'RetryWithError',
  FINISHED_WITH_ERROR = 'FinishedWithError'
}

export type CodeGenStatusType = `${CodeGenStatus}`;

export enum ProjectBrowserTab {
  Chat = 'chat',
  Project = 'project',
  Environment = 'environment'
}

export enum UISpecCategory {
  'SourceTarget' = 'Source/Target',
  'Transform' = 'Transform',
  'JoinSplit' = 'Join/Split',
  'Custom' = 'Custom',
  // 'MyGems' = 'My Gems',
  'MachineLearning' = 'Machine Learning',
  'Hidden' = 'Hidden',
  'Subgraph' = 'Subgraph'
}

export enum SqlUISpecCategory {
  SourceTarget = 'Source/Target',
  Transform = 'Transform',
  Prepare = 'Prepare',
  JoinSplit = 'Join/Split',
  Parse = 'Parse',
  Report = 'Report',
  Subgraph = 'Subgraph',
  Custom = 'Custom',
  Model = 'Model',
  Sensor = 'Sensor',
  Spatial = 'Spatial'
}

export enum AirflowUISpecCategory {
  Operator = 'Operator',
  Sensor = 'Sensor',
  TriggerNotify = 'Trigger/Notify',
  SparkSQL = 'Spark/SQL',
  DataPipelines = 'Data Pipelines',
  Custom = 'Custom',
  DataTransfer = 'Data Transfer',
  Subgraph = 'Subgraph'
}
export enum DownloadFormat {
  json = 'json',
  csv = 'csv',
  xlsx = 'xlsx'
}
